// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { QueueAlertAction } from '../state/alerts.actions';
import { AlertType } from '../models';

@Injectable()
export class AlertService {

    constructor(private store: Store<any>) {
    }

    success (alertText: string) {
        this.store.dispatch(new QueueAlertAction({ alertText, alertType: AlertType.SUCCESS }));
    }

    error (alertText: string) {
        this.store.dispatch(new QueueAlertAction({ alertText, alertType: AlertType.ERROR }));
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/alert.service.ts